import { makeAutoObservable } from "mobx";

import { MdmCardFormStore } from "./MdmCardForm/MdmCardFormStore";
import { ex1data } from "./MdmCardForm/stubs/ex1data";
import { ex1metaGrid, ex1metaSubGrid } from "./MdmCardForm/stubs/ex1metaGrid";
import { ex1metaTabs } from "./MdmCardForm/stubs/ex1metaTabs";
import { createFormItem } from "./MdmCardForm/types/createFormItem";
import { zRecord } from "./MdmCardForm/types/dataTypes";
import { zMetaNode } from "./MdmCardForm/types/metaTypes";

type DataItem = {
  name: string;
  data: string;
};
type DataItemSrc = {
  name: string;
  dataSrc: unknown;
};

const srcData = [
  {
    name: "Meta 1",
    dataSrc: ex1metaGrid,
  },
  {
    name: "Meta 1Sub",
    dataSrc: ex1metaSubGrid,
  },
  {
    name: "Meta Tabs",
    dataSrc: ex1metaTabs,
  },
  {
    name: "Data 1",
    dataSrc: ex1data,
  },
] satisfies DataItemSrc[];

export const mdmCardDemoStore = makeAutoObservable({
  dataItems: [] as DataItem[],
  topTab: "data",
  setTopTab(key: string) {
    this.topTab = key;
  },
  dataTab: srcData[0]!.name,
  setDataTab(name: string) {
    this.dataTab = name;
  },
  get curData(): string {
    const item = this.dataItems.find(({ name }) => name === this.dataTab);
    return item?.data ?? "";
  },
  setCurData(data: string) {
    const item = this.dataItems.find(({ name }) => name === this.dataTab);
    if (item) {
      item.data = data;
    }
  },

  init() {
    this.dataItems = srcData.map(({ name, dataSrc }) => ({
      name,
      data: JSON.stringify(dataSrc, null, "  "),
    }));
  },

  formStore: new MdmCardFormStore(),

  async loadMetaFromData(dataName: string) {
    const dataItem = this.dataItems.find(({ name }) => name === dataName);
    if (!dataItem) {
      throw Error(`Не найдены данные ${dataName}`);
    }
    const json = JSON.parse(dataItem.data);
    const meta = zMetaNode.parse(json);
    const root = createFormItem(null, meta, {
      basePath: "",
      form: this.formStore,
    });
    this.formStore.setMetaRoot(root);
    this.formStore.startValidating();
  },

  async loadData(dataName: string) {
    const dataItem = this.dataItems.find(({ name }) => name === dataName);
    if (!dataItem) {
      throw Error(`Не найдены данные ${dataName}`);
    }
    const json = JSON.parse(dataItem.data);
    const data = zRecord.parse(json);
    this.formStore.setDataRoot(data);
    this.formStore.startValidating();
  },
});
